import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ReorganizationOptions = ({ zoneSwap, wallBorders, onZoneSwapChange, onWallBordersChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const getHintText = () => {
    const zone = zoneSwap ? 'swapped between rooms' : 're-arranged within existing zones';
    const wall = wallBorders ? 'kept within wall boundaries' : 'allowed to ignore wall boundaries';
    return `Furniture will be ${zone}, ${wall}`;
  };

  return (
    <div className="glassmorphic-card rounded-3xl p-6">
      {/* Collapsible header */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between"
      >
        <div className="flex items-center gap-2">
          <h3 className="text-[12.6px] font-medium text-white">Advanced Settings</h3>
          <span className="text-white/30 text-[11px]">Reorganization Options</span>
        </div>
        <Icon
          name="ChevronDown"
          size={16}
          className={`text-white/40 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
        />
      </button>

      {/* Collapsible content */}
      {isOpen && (
        <div className="mt-5">
          <div className="space-y-4">
            {/* Zone toggle: left = Keep zones (default/off), right = Swap room positions (on) */}
            <div className="flex items-center gap-3">
              <span className={`text-sm transition-colors duration-200 min-w-[120px] text-right ${
                !zoneSwap ? 'text-white' : 'text-white/30'
              }`}>
                Keep room positions
              </span>
              <button
                onClick={() => onZoneSwapChange(!zoneSwap)}
                className="relative w-14 h-7 rounded-full transition-all duration-300 bg-orange-500 flex-shrink-0"
              >
                <div className={`absolute top-0.5 left-0.5 w-6 h-6 bg-white rounded-full shadow-md transition-transform duration-300 ${
                  zoneSwap ? 'translate-x-7' : 'translate-x-0'
                }`} />
              </button>
              <span className={`text-sm transition-colors duration-200 ${
                zoneSwap ? 'text-white' : 'text-white/30'
              }`}>
                Swap room positions
              </span>
            </div>

            {/* Wall toggle: left = Keep wall borders (default/off), right = Ignore walls (on) */}
            <div className="flex items-center gap-3">
              <span className={`text-sm transition-colors duration-200 min-w-[120px] text-right ${
                !wallBorders ? 'text-white' : 'text-white/30'
              }`}>
                Keep wall borders
              </span>
              <button
                onClick={() => onWallBordersChange(!wallBorders)}
                className="relative w-14 h-7 rounded-full transition-all duration-300 bg-orange-500 flex-shrink-0"
              >
                <div className={`absolute top-0.5 left-0.5 w-6 h-6 bg-white rounded-full shadow-md transition-transform duration-300 ${
                  wallBorders ? 'translate-x-7' : 'translate-x-0'
                }`} />
              </button>
              <span className={`text-sm transition-colors duration-200 ${
                wallBorders ? 'text-white' : 'text-white/30'
              }`}>
                Ignore wall borders
              </span>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ReorganizationOptions;
